<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="guideIndex" :areaShow="areaShow" :get-party-id="getPartyId" :reloadFlag="reloadFlag"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a  href="javascript:void(0)" @click="urlTo('applyIndex')">个人办事</a> / <span>办事指南</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="guide_con">
            <div class="guide_left">
              <h2 class="tit6"><img src="../../../static/images/guide_sign1.png">{{nav_name}}</h2>
              <dl v-if="dataObjList && dataObjList.length>0">
                 <el-tabs v-model="activeName" >
                  <el-tab-pane  v-for="(item, index) in dataObjList" :key="item.tabId" :label="item.tabName" :name="index+''">
                    <div style="width:100%" v-if="item.indexData!=null && item.indexData.length>0">
                      <div style="width:100%" v-if="item.showWay == '0'">
                        <div  style="width:100%" v-for="(items, indexs) in item.indexData" :key="items.itemId">
                          <div  v-if="items.itemType=='0'" class="_div_width _div_height _title_div _div_botton_border">{{items.title}}</div>
                          <!--<div class="_div_width _div_height _div_botton_border" style="font-size: 14px;color: #303133;"  v-if="items.itemType=='1'" >{{items.title}}</div>-->
                          <div class="_div_width _div_botton_border"  v-if="items.itemType=='2'" >
                            <div class="_div_height _title_div" style="font-size: 14px;color: #303133;"><b>{{items.title}}</b></div>
                            <div class="_div_height _content_div" style="font-size: 12px;color: #85888e;">{{items.content}}</div>
                          </div>
                          <div class="_div_width _div_botton_border _div_flex"  v-if="items.itemType=='3'">
                            <div class="_div_height _form_title" style="font-size: 14px;color: #303133;">{{items.title}}</div>
                            <div class="_div_height _form_value" style="font-size: 12px;color: #85888e;">{{items.content}}</div>
                          </div>
                          <div class="_div_width _div_botton_border _div_flex"  style="height: 30px;line-height: 30px;" v-if="items.itemType=='1'">
                            <div class="_div_height _form_title" style="font-size: 13px;color: #303133;">{{items.title}}</div>
                            <div class="_div_height _form_value" style="font-size: 12px;color: #85888e;">
                              <el-link type="primary" :href="getFileUrl(items.attachId)" target="_blank" style="font-size: 13px">下载</el-link></div>
                          </div>
                        </div>
                      </div>
                      <div style="width:100%" v-if="item.showWay == '1'" class="stepDivCss">
                        <el-steps direction="vertical" :active="-1" space="60px">
                          <el-step v-for="(items, indexs) in item.indexData" :key="items.itemId" :title="items.title" :description="items.content" v-if="items.itemType != '1'" ></el-step>
                          <el-step v-for="(items, indexs) in item.indexData" :key="items.itemId" :title="items.title"  v-if="items.itemType == '1'" >
                            <template slot="description">
                              <span style="font-size:10px"> <img  style="width: 80%;height: auto;margin-bottom: 20px;margin-top: 10px;" :src="getFileUrl(items.attachId)"/></span>
                            </template>

                          </el-step>
                        </el-steps>

                      </div>
                    </div>
                    <div v-else>  <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 20px;">
                      <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                      <div>暂无数据</div>
                    </div></div>
                  </el-tab-pane>
                </el-tabs>
              </dl>
              <dl v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 20px;">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </dl>
            </div>
            <div class="guide_right">
              <div class="guide_right1">
                <p class="tit7">服务承诺</p>
                <ul v-if="service_code=='OLD' || service_code=='old' ">
                  <li><span>1次</span> <br /><em>到现场次数</em></li>
                  <li ><span>2个工作日</span> <br /><em>法定办结时限</em></li>
                  <li><span>2个工作日</span> <br /><em>承诺办结时限</em></li>
                </ul>
                <ul v-else-if="service_code=='JDST' || service_code=='ORP' || service_code=='BLAN_ORP'">
                  <li><span>1次</span> <br /><em>到现场次数</em></li>
                  <li ><span>15个工作日</span> <br /><em>法定办结时限</em></li>
                  <li><span>15个工作日</span> <br /><em>承诺办结时限</em></li>
                </ul>
                <ul v-else>
                  <li><span>1次</span> <br /><em>到现场次数</em></li>
                  <li ><span>25个工作日</span> <br /><em>法定办结时限</em></li>
                  <li><span>25个工作日</span> <br /><em>承诺办结时限</em></li>
                </ul>
                <div class="guide_right1_button"><a href="javascript:void(0)" @click="gotoBl">立即申报</a></div>
              </div>
              <div class="guide_right2">
                <p class="tit7">办事指南评分</p>
                <div class="guide_right2_star" style="padding-left: 10%;padding-bottom: 48px">
                  <el-rate
                    v-model="guideScore"
                    disabled
                    show-score
                    text-color="#ff9929"
                    score-template="{value}">
                  </el-rate>
                </div>
                <div class="guide_right2_button"><a href="javascript:void(0)" @click="urlTo('guideIndexList',{service_code:service_code,nav_name:nav_name_apply,guideId:guideId})" style="font-size: 14px;">查看评价</a><a style="font-size: 14px;" href="javascript:void(0)" @click="scoreShow=true">评价指南</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog_css">
      <el-dialog  :visible.sync="scoreShow" width="590px" :close-on-click-modal="false" :show-close="true">
        <div>
          <div class="popup2_con">
            <div class="popup2_tit"><span>办事指南评议</span></div>
            <div class="popup2-box">
              <el-rate
                v-model="newScore"
                show-text :texts="['非常不满意', '不满意', '基本满意', '满意', '非常满意']">
              </el-rate>
              <div class="popup2_text">
                <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入评价内容"
                v-model="scoreContent" maxlength="180">
              </el-input></div>
              <div class="popup2_button"><a href="javascript:void(0)" @click="saveScore">确定</a></div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div style="line-height: 35px;">
      <el-dialog  :visible.sync="clauseShow" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">{{this.cTitle}}</div>
        <div style="font-size: 14px;margin-left: 40px;margin-right: 35px;"><p v-html="this.cContent">{{this.cContent}}</p></div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button type="primary" @click="gotoBl" >我已详细阅读</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>

</template>

<script>
import headers from "../../components/Headers";
import fixedDiv from "../../components/FixedDiv";
import footers from "../../components/Footer";
export default {
    inject:['reload'],
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'guideIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      party_id:'63010001',
      nav_name:'',
      nav_name_apply:'',
      cTitle:'',
      cContent:'',
      service_code:'',
      dataObjList:[],
      activeName:'0',
      areaShow:false,
      guideScore:0,
      guideId:'',
      scoreShow:false,
      clauseShow:false,
      newScore:5,
      scoreContent:'',
        reloadFlag:false,
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
    guideId:function(){
      if(this.guideId){
        this.getGuideScoreWeb();
      }
    }
  },
  created(){
    this.browseLog();
  },
  mounted(){
    if(!this.party_id){
      this.areaShow=true;
    }
      //从地址中获取code，如果code存在，则静默登录


    this.qhszwtLogin();
    this.initData();
  },
  methods: {
    handleClick(){},
    getPartyId(a){
      this.party_id=a;
      //加载办事指南数据
      this.initData();
    },
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    browseLog(){
      const options={
        oneCode:'bmcx',
        twoCode:'bszlcx',
      }
      this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
      })
    },
    clauseClose(){
      this.clauseShow=false;
    },
    getFileUrl(a){
      return this.$util.getAttach(a)
    },
    getGuideScoreWeb(){
      if(!this.guideId){
        return;
      }
      const options={
        guideId:this.guideId,
      }
      this.$https.post("api/guide/getGuideScoreWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200 && response.data.data) {
            this.guideScore=response.data.data;
        }
      })
    },
      qhszwtLogin(){

          let code=this.$route.query.code;
          let token_code=this.$route.query.token_code;

          var userInfo=this.$cookies.get('userInfo')
          if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1) {
              if(token_code && token_code !=''){
              const options = {
                  code: code,
                  token_code: token_code
              }
                  console.log("进来了131")
              var tt = this;
              this.$https.post("api/pu/qhzwfwLogin.do", options, response => {
                  if (response.status === 200 && response.data.code === 200 && response.data.data) {
                      tt.$cookies.set("userId", response.data.data.userId, "1D")
                      tt.$cookies.set("token", response.data.data.token, "1D")
                      tt.$cookies.set("userInfo", response.data.data, "1D")
                      tt.$cookies.set("isLegal", response.data.data.isLegal, "1D")
                      tt.isLogin = true;
                      tt.userName = response.data.data.userName;
                      tt.reloadFlag = true;
                  }
              })

          }else{
                  console.log("324324")
              }
          }else{
              console.log("进来了1135")
          }
      },
    initData(){
        this.service_code=this.$route.query.service_code;
        let nav_name=this.$route.query.nav_name;
        if(this.service_code=='OLD'){
            nav_name='高龄津贴';
        }else if(this.service_code=='CLP_LIV'){
            nav_name='残疾人生活补贴';
        }else if(this.service_code=='JDST'){
            nav_name='节地生态葬补贴';
        }else if(this.service_code=='ORP'){
            nav_name='孤儿生活费';
        }else if(this.service_code=='BLAN_ORP'){
            nav_name='事实无人抚养儿童生活费';
        }else if(this.service_code=='BLAN_ORP'){
            nav_name='事实无人抚养儿童生活费';
        }
      this.nav_name=nav_name+"办事指南";
      this.nav_name_apply=nav_name;

      if(!this.party_id){
        return;
      }


      const options={
        service_code:this.service_code,
        area_id:this.party_id
      }
      this.$https.post("api/guide/getGuideWeb.do",options,response=>{
        if (response.status === 200 && response.data.code===200 && response.data.data) {
          if(response.data.data.listData){
            this.dataObjList=response.data.data.listData;
          }
          if(response.data.data.guideId){
            this.guideId=response.data.data.guideId;
          }
        }
      })
    },
    saveScore(){
      if(!this.guideId){
        this.scoreShow=false;
        return;
      }
      const options={
        guideId:this.guideId,
        newScore:this.newScore,
        scoreContent:this.scoreContent
      }
      var tt=this;
      this.$https.post("api/guide/guideScoreWeb.do",options,response=>{
          tt.newScore=5;
          tt.scoreContent='';
           tt.$message({
          message: '办事指南评价成功，感谢您的反馈！',
          type: 'success',
          duration:2500,
          onClose:function(){
            tt.scoreShow=false;
            tt.getGuideScoreWeb();
          }
        });
        // if (response.status === 200 && response.data.code===200 && response.data.data) {
        //   if(response.data.data.listData){
        //     this.dataObjList=response.data.data.listData;
        //   }
        //   if(response.data.data.guideId){
        //     this.guideId=response.data.data.guideId;
        //   }
        // }
      })
    },
    showClause(type){
      this.$https.get("api/pu/clause/getClauseContentByType.do",{cType:type},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.cTitle=response.data.data.cTitle;
          this.cContent=response.data.data.cContent;
        } else {

        }
      })
      this.clauseShow=true;
    },
    gotoBl(){
      let isLegal= this.$cookies.get('isLegal')
      if(isLegal && isLegal ==='1'){
        this.$message({
          message: '登录账户为法人账户，不具备业务申办权限；请退出法人账户，使用个人账户登录办理业务。',
          type: 'warning'
        });
        return
      }
      if('BLAN'==this.service_code || 'NTF'==this.service_code){
        this.urlTo('blanApply',{archive_type_code:this.service_code,nav_name:this.nav_name_apply,canEdit:true})
      }
      // else if('CLP_LIV'==this.service_code || 'CLP_HLF'==this.service_code){
      //   this.urlTo('clpApply',{archive_type_code:this.service_code,nav_name:this.nav_name_apply,canEdit:true})
      // }else if('ORP'==this.service_code || 'POC'==this.service_code || 'SPEC_ORP'==this.service_code || 'BLAN_ORP'==this.service_code){
      //   this.urlTo('pocApply',{archive_type_code:this.service_code,nav_name:this.nav_name_apply,canEdit:true})
      // }
      else if('JDST'==this.service_code){
        this.urlTo('jdApply',{archive_type_code:this.service_code,nav_name:this.nav_name_apply,canEdit:true})
      }
      else{
        this.urlTo('tyApply',{archive_type_code:this.service_code,nav_name:this.nav_name_apply,canEdit:true})
      }
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>
  ._div_botton_border{
    border-bottom: 1px solid #ebedf0;
  }
  ._div_flex{
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-direction: row;
  }
  ._div_width{
    width: 100%;
  }
  ._div_height{
    line-height: 26px;
  }
  ._form_title{
    width: 30%;

  }
  ._form_value{
    width: 70%;

  }
  ._title_div{
    height: 30px;
    line-height: 30px;
    font-size: 14px;

  }
  ._content_div{
    font-size: 14px;
    line-height: 30px;
  }
  .stepDivCss .el-step__description {
    padding-right: 10%;
    margin-top: -5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 20px;
    color:#85888e;
  }
  .stepDivCss .el-step__title {
    font-size: 14px;
    line-height: 38px;
    font-weight: 600;
    color: #4277e5;
  }
  .stepDivCss .el-step__head.is-wait {
    color: #2e63e9;
    border-color: #4277e5;
  }
  .stepDivCss .el-step__line {
    position: absolute;
    border-color: inherit;
    background-color: #4277e5;
  }
  .stepDivCss .el-step:last-of-type .el-step__description{
    padding-right: 10%;
  }
.popup2-box .el-rate__icon {
  font-size: 30px;
  margin-right:0px;
  color: #C0C4CC;
  -webkit-transition: .3s;
  transition: .3s;
}

  .popup2-box .el-rate__text {
    font-size: 14px;
    vertical-align: middle;
    margin-left: 10px;
  }
 .guide_right2_star .el-rate__icon {
    font-size: 30px;
    margin-right:0px;
    color: #C0C4CC;
    -webkit-transition: .3s;
    transition: .3s;
  }

  .dialog_css .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .dialog_css .el-dialog__header {
    padding: 0px;
  }
  .dialog_css .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
    font-weight: 900;
  }
</style>



// WEBPACK FOOTER //
// src/pages/guide/GuideIndex.vue